/*
 * Module for Snag Grid page
 */
rs.module("content/development/snaggrid",

    [],

    function () {

        // Initialize the page
        function initialize(jsSelectors) {

            var form = $.js(jsSelectors.form);
            var inlineEditingCheckBox = form.js(jsSelectors.inlineEditingCheckBox);
            var rowSelectionNoneRadio = form.js(jsSelectors.rowSelectionNoneRadio);
            var rowSelectionSingleRadio = form.js(jsSelectors.rowSelectionSingleRadio);
            var rowSelectionMultipleRadio = form.js(jsSelectors.rowSelectionMultipleRadio);

            // Register inlineEditingCheckBox changed event
            inlineEditingCheckBox.change(function () {
                enableDisableFields();
            });

            // Handle conditional enabling/disabling of form fields
            function enableDisableFields() {

                var inlineEditing = inlineEditingCheckBox.is(":checked");

                if (inlineEditing) {
                    rowSelectionNoneRadio.setChecked(true);              
                }

                rowSelectionNoneRadio.setDisabled(inlineEditing);
                rowSelectionSingleRadio.setDisabled(inlineEditing);
                rowSelectionMultipleRadio.setDisabled(inlineEditing);          
            }
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);